import React, { useEffect, useState } from 'react';
import { AvForm } from 'availity-reactstrap-validation';
import { useSelector, useDispatch } from 'react-redux';
import { Label, FormGroup } from 'reactstrap';
import {
  AddButton,
  Buttons,
  CancelButton,
  DeleteButton,
  UpdateButton,
} from '../../components/Common/iComponents/iPopUp/IpopUp';
import { ISelector } from '../../components/Common/iComponents/iSelector/iSelector';
import { ISwitch } from '../../components/Common/iComponents/iSwitch/iSwitch';
import { IInput } from '../../components/Common/iComponents/iInput/iInput';
import { getClients, getSyncConfiguration } from '../../store/actions';

type IFormProps = {
  selectedRow: any;
  onCreateConfig: Function;
  onUpdateConfig: Function;
  onDeleteConfig: Function;
  onCancel: Function;
  filters: any;
};

const IForm = ({
  selectedRow,
  onCreateConfig,
  onUpdateConfig,
  onDeleteConfig,
  onCancel,
  filters
}: IFormProps) => {
  const dispatch = useDispatch();
  const arrayUpdAdd = [
    'clientId',
    'OperationType',
    'WorkflowEnabled',
    'SyncEnabled',
  ];
  const [form, setForm] = useState({
    clientId: '',
    OperationType: '',
    WorkflowEnabled: '',
    SyncEnabled: '',
    enabled: false,
  });
  const [flag, setflag] = useState<boolean>(true);

  const { filterItems } = useSelector(
    (state: any) => state.SyncConfiguration,
  );
  const operations = filterItems.find(
    (f: any) => f.dataField === 'OperationType',
  ).data;
  const { clients } = useSelector((state: any) => state.clients);
  const valuesSizeRolesPagination = [20, 40, 60, 80, 100, 200];

  const [pagination, setPagination] = useState<any>({
    sizePerPage: valuesSizeRolesPagination[0],
    page: 1,
  });

  const initialArrayTableRoles = [
    {
      text: 'Operation',
      dataField: 'name',
      formatter: (cellContent: any, op: any) => (
        <>
          {op.id} - {op.name}
        </>
      ),
      hidden: false,
    },
  ];
  const initialArrayTableClients = [
    {
      text: 'Name',
      dataField: 'id',
      formatter: (cellContent: any, client: any) => (
        <>
          {client.id} - {client.name}
        </>
      ),
      hidden: false,
    },
  ];

  const handlePaginationChange = (newState: any) => {
    setPagination(newState);
  };

  useEffect(() => {
    if (selectedRow) {
      if (operations.length === 0) {
        dispatch(getSyncConfiguration({ pagination, filters }));
      }
      if (clients.length === 0) {
        dispatch(getClients({}));
      }
      setForm(selectedRow);
    }
  }, [clients.length, dispatch, operations.length, pagination, selectedRow]);

  useEffect(() => {
    dispatch(getClients({}));
    dispatch(getSyncConfiguration({ pagination, filters }));
  }, [selectedRow, pagination, dispatch]);

  const itemVals = (val: any, updateVal: any) => {
    for (const property in updateVal) {
      if (property === val) {
        return updateVal[property];
      }
    }
  };
  const renderButtons = () => (
    <Buttons>
      {selectedRow ? (
        <>
          <CancelButton
            className="button"
            onClick={() => onCancel()}
            data-bs-toggle="tooltip"
          >
            <i
              className="bx bx-power-off"
              style={{ fontSize: '2.5em' }}
              data-bs-toggle="tooltip"
            ></i>
          </CancelButton>
          <DeleteButton
            className="btn-delete"
            onClick={() => onDeleteConfig(selectedRow.id)}
          >
            <i className="dripicons-trash" style={{ fontSize: '1.7em' }}></i>
          </DeleteButton>
          <UpdateButton
            className="button"
            disabled={flag}
            onClick={() => onUpdateConfig(form)}
          >
            <i className="bx bx-sync" style={{ fontSize: '2.5em' }}></i>
          </UpdateButton>
        </>
      ) : (
        <AddButton
          type="submit"
          disabled={flag}
          className="btn"
          onClick={() => {
            onCreateConfig(form);
          }}
        >
          <i className="bx bx-user-check" style={{ fontSize: '3.5em' }} />
        </AddButton>
      )}
    </Buttons>
  );

  useEffect(() => {
    const { clientId, OperationType } = form;
    if (clientId && OperationType) {
      if (clientId && OperationType) {
        setflag(false);
      }
    } else {
      setflag(true);
    }
  }, [form]);

  const onChangeBooleanHandler = (e: any, n: any) => {
    setForm((prev) => ({
      ...prev,
      [n]: !form[n as keyof typeof form],
    }));
  };
  const onChangeSelectorHandler = (n: any, value: any) => {
    setForm((prev) => ({
      ...prev,
      [n]: n === 'clientId' ? String(value.id) : String(value.name),
    }));
  };
  const onChangeHandler = (e: any, n: any) => {
    setForm((prev) => ({
      ...prev,
      [n]: e.target.value,
    }));
  };
  const renderFields = () => {
    return arrayUpdAdd?.map((val: any) => {
      const nameObject = val as keyof typeof form;
      const temp = form[nameObject];
      const valid = !!temp;
      const type = '';
      let nameSelector = '';
      const value = selectedRow ? itemVals(val, selectedRow) : null;

      switch (val) {
        case 'OperationType':
          nameSelector =
            value || value === null
              ? operations.filter((item: any) => item.name === temp)[0]?.name
              : '';
          return (
            <div className="m-2">
              <ISelector
                title={val}
                value={String(temp)}
                nameSelector={nameSelector ?? ''}
                valuesSizePagination={valuesSizeRolesPagination}
                dataSelector={operations}
                remote={true}
                CountItems={operations.length}
                initialArrayTable={initialArrayTableRoles}
                handlePaginationChange={handlePaginationChange}
                setSelectedRow={onChangeSelectorHandler}
                onChangeHandler={onChangeHandler}
              />
            </div>
          );
        case 'clientId':
          nameSelector =
            value || value === null
              ? clients.filter(
                  (item: any) => Number(item.id) === Number(temp),
                )[0]?.name
              : '';
          return (
            <div className="m-2">
              <ISelector
                title={val}
                value={String(temp)}
                nameSelector={nameSelector ?? ''}
                dataSelector={clients}
                CountItems={'10'}
                initialArrayTable={initialArrayTableClients}
                setSelectedRow={onChangeSelectorHandler}
                onChangeHandler={onChangeHandler}
              />
            </div>
          );
        // Estos campos se renderizan aparte
        case 'WorkflowEnabled':
          return null;
        case 'SyncEnabled':
          return null;

        default:
          break;
      }

      return (
        <IInput
          title={val}
          valid={valid}
          value={value}
          type={type}
          onChangeHandler={onChangeHandler}
        />
      );
    });
  };
  const renderSwitches = () => {
    return arrayUpdAdd?.map((val: any) => {
      const nameObject = val as keyof typeof form;
      if (val === 'WorkflowEnabled' || val === 'SyncEnabled') {
        return (
          <FormGroup className="text-center">
            <div className="text-capitalize">
              <Label>{val}</Label>
            </div>
            <Label>
              <ISwitch
                title={val}
                checked={!!form[nameObject]}
                onChangeBooleanHandler={onChangeBooleanHandler}
              />
            </Label>
          </FormGroup>
        );
      }
      return null;
    });
  };

  return (
    <>
      <div className="d-flex flex-column">
        <div className="w-auto align-self-center" style={{ height: '450px' }}>
          <AvForm className="custom-form mt-0">
            {renderFields()}
            <div className="d-flex justify-content-around">
              {renderSwitches()}
            </div>
          </AvForm>
        </div>
        <div className="d-flex justify-content-end m-1">{renderButtons()}</div>
      </div>
    </>
  );
};

export default IForm;
